import React, {Component} from "react";
import "./UserInquiryForm.css";
import {FormattedMessage} from "react-intl";
import {Redirect} from 'react-router'
import FormFieldValidationError from '../../Common/FormFieldValidationError/FormFieldValidationError';
import axios from "axios";
import {BASE_URL, RESOURCE_BASE_URL} from "../../../configuration";
import Modal from "react-bootstrap/es/Modal";
import {ReCaptcha} from 'react-recaptcha-google';
import {toast, ToastContainer} from "react-toastify";
import {css} from "glamor";
import InitialQuotationState from "../QuotationForm/InitialQuotationState";
import GoogleAds from "../../Common/GoogleAds/GoogleAds";

// import {FilePond,registerPlugin} from "react-filepond";

class UserInquiryForm extends Component {

    componentDidMount() {
        window.scrollTo(0, 0);
        if (InitialQuotationState.fromFlow) {
            this.setState({
                subject: 'REQUEST'
            })
        }

        if(InitialQuotationState.loggedUserId !== null){
            this.getUserForUserId();
        }
    }

    constructor(props, context) {
        super(props, context);
        this.onLoadRecaptcha = this.onLoadRecaptcha.bind(this);
        this.verifyCallback = this.verifyCallback.bind(this);

        let today = new Date();
        let date = today.getFullYear() + '年 ' + (today.getMonth() + 1) + '月 ' + today.getDate() + '日 ';

        this.state = {
            show: false,
            user : null,
            name: "",
            email: "",
            subject: "QUOTATION_RELATED",
            inquiry: "",
            nameError: "",
            emailError: "",
            subjectError: "",
            inquiryError: "",
            date: date,
            redirect: false,
            reCaptchaResponse: "",
            btnDisabled: false,  // todo Turn this to true when recaptcha is needed
            files: [
                {
                    source: "index.html",
                    options: {
                        type: "local"
                    }
                }
            ]
        };

        this.onInputChange = this.onInputChange.bind(this);
        this.validateName = this.validateName.bind(this);
        this.validateEmail = this.validateEmail.bind(this);
        this.validateSubject = this.validateSubject.bind(this);
        this.validateInquiry = this.validateInquiry.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleShow = this.handleShow.bind(this);
        this.getUserForUserId = this.getUserForUserId.bind(this);

    }


    handleClose = () => {
        this.setState({
            show: false
        }, () => {
            this.props.handle(false);
            if(window.location.href === BASE_URL+'inquiry'){
                window.location.replace(BASE_URL);
            }
        });

    };

    handleShow = () => {
        this.setState({
            show: true
        })
    };


    validateName = () => {
        let name = this.state.name;
        return (name !== "");
    };

    validateEmail = () => {
        let email = this.state.email;
        // let pattern = /^[a-zA-Z0-9.]+@[a-zA-Z0-9.]+\.[a-zA-Z]{2,4}/;
        let pattern =  /[A-Z0-9._%+-]+@[A-Z0-9.-]+.[A-Z]{2,4}/igm;

        return email.match(pattern);
    };

    validateSubject = () => {
        let subject = this.state.subject;
        return (subject !== "");
    };

    validateInquiry = () => {
        let inquiry = this.state.inquiry;
        return (inquiry !== "");
    };

    onInputChange = (event) => {
        // console.log("================================================================>>>>>>>>>>>>>  ",event.target.value);
        this.setState({
            [event.target.name]: event.target.value,
            nameError: "",
            emailError: "",
            subjectError: "",
            inquiryError: "",

        });


    };


    saveInquiry(user) {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };
        axios.post(RESOURCE_BASE_URL + 'api/users/inquiries'
            , {
                name: this.state.name,
                email: this.state.email,
                subject: this.state.subject,
                message: this.state.inquiry,
                userId: user
            }, axiosConfig)
            .then((res) => {
                // console.log("New inquiry added", res);
               this.handleClose();

            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
            });
        /*toast("Inquiry Submitted successfully!",{className: css({
                background: "#55bb22 !important",
                width: "auto",
                padding:"25px",
                color:"#000000 !important"
            })
        }, {autoClose: 2000});*/

    }

    onSubmit = event => {

        event.preventDefault();

        let nameError = "";
        let emailError = "";
        let subjectError = "";
        let inquiryError = "";
        let validationPassed = true;
        let user = "";

        if (!this.validateName(event)) {
            validationPassed = false;
            nameError = "app.validation.inquiry.invalid-name";
        }
        if (!this.validateEmail(event)) {
            validationPassed = false;
            emailError = "app.validation.inquiry.invalid-email";
        }

        if (!this.validateSubject(event)) {
            validationPassed = false;
            subjectError = "app.validation.inquiry.invalid-subject";
        }

        if (!this.validateInquiry(event)) {
            validationPassed = false;
            inquiryError = "app.validation.inquiry.invalid-inquiry";
        }

        if (validationPassed) {
            if (this.captchaDemo) {
                // console.log("started, just a second...");
                this.captchaDemo.reset();

                this.setState({show: true});

            }
            if (localStorage.getItem("userId") === null) {
                user = 'unregistered';
            } else {
                user = localStorage.getItem("userId");
            }
            this.saveInquiry(user);
            // this.props.handle(false);

        } else {

            this.setState({nameError, emailError, subjectError, inquiryError});
        }
    };

    onLoadRecaptcha() {
        if (this.captchaDemo) {
            this.captchaDemo.reset();
        }
    }

    verifyCallback(recaptchaToken) {
        this.setState({
            btnDisabled: false,
            reCaptchaResponse: recaptchaToken
        });
        // console.log(recaptchaToken, "<= yoQuality Complaintsur recaptcha token")
    }

    getUserForUserId = () => {
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        axios.get(RESOURCE_BASE_URL + 'api/users/' + localStorage.getItem("userId"), axiosConfig)
            .then((res) => {
                this.setState({
                    user : res.data,
                    name : res.data.name,
                    email : res.data.email
                },()=>console.log("USER DATA INQUIRY =======>"))
            })
            .catch((err) => {
                console.log("[API] ERROR: ", err);
                console.log("Token invalid");
                localStorage.clear();
                window.location.replace(BASE_URL + "login");
            });
    };

    render() {

        // console.log("USER ID INQUIRY FORM ======> ", InitialQuotationState.loggedUserId);
        const {redirect} = this.state;

        if (redirect) {
            return <Redirect to=''/>;
        }

        return (
            <div className="user-inquiry-form-content">
                <GoogleAds slot="696274611" />
                <div className="user-inquiry-form-div">
                    {/*<form onSubmit={this.onSubmit}>*/}

                    {/*<div className="title-1 text-align-left">*/}
                    {/*<FormattedMessage id="app.inquiry-form.title"*/}
                    {/*defaultMessage="INQUIRY"*/}
                    {/*description=""/>*/}
                    {/*</div>*/}
                    {/*<hr/>*/}
                    <div className="row">
                        <div className="user-inquiry-form-row-margin">
                            <div className="col-md-3">
                                <div className="text-right">
                                    <label>
                                        {/*<FormattedMessage id="app.inquiry-form.date"*/}
                                        {/*defaultMessage="Date:"*/}
                                        {/*description=""/>*/}
                                        日付
                                        <span className="mandatory-star"> </span>
                                    </label>
                                </div>
                            </div>
                            <div className="col-md-6 no-padding-left inquiry-date-div">
                                {this.state.date}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="user-inquiry-form-row-margin">
                            <div className="col-md-3">
                                <div className="text-right">
                                    <label>
                                        <FormattedMessage id="app.inquiry-form.name"
                                                          defaultMessage="Name"
                                                          description=""/>
                                    </label>
                                </div>
                            </div>
                            <div className="col-md-6 no-padding-left inquiry-div">
                                {this.state.name}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-offset-3">
                            <FormFieldValidationError errors={this.state.nameError}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="user-inquiry-form-row-margin">
                            <div className="col-md-3">
                                <div className="text-right">
                                    <label>
                                        <FormattedMessage id="app.inquiry-form.email"
                                                          defaultMessage="Email"
                                                          description=""/>
                                    </label>
                                </div>
                            </div>
                            <div className="col-md-6 no-padding-left inquiry-div">
                                {this.state.user !== null ?
                                    <span>{this.state.user.email}</span> :
                                    <input type="text"
                                           className="form-control input-sm"
                                           name="email"
                                           value={this.state.email}
                                           onChange={this.onInputChange}
                                           id = "emailID"
                                    />
                                }

                                {/*<input type="text"*/}
                                       {/*className="form-control input-sm"*/}
                                       {/*name="email"*/}
                                       {/*value={this.state.email}*/}
                                       {/*onChange={this.onInputChange}*/}
                                {/*/>*/}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-offset-3">
                            <FormFieldValidationError errors={this.state.emailError}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="user-inquiry-form-row-margin">
                            <div className="col-md-3">
                                <div className="text-right">
                                    <label>
                                        <FormattedMessage id="app.inquiry-form.subject"
                                                          defaultMessage="Subject"
                                                          description=""/>
                                        <span className="mandatory-star"> *</span>
                                    </label>
                                </div>
                            </div>
                            <div className="col-md-6 no-padding-left">
                                {/*<input type="text"*/}
                                {/*className="form-control input-sm"*/}
                                {/*name="subject"*/}
                                {/*value={this.state.subject}*/}
                                {/*onChange={this.onInputChange}*/}
                                {/*/>*/}

                                {InitialQuotationState.fromFlow ?
                                    <span>
                                       無料基板サンプル請求
                                    </span> :
                                    <select
                                        value={this.state.subject}
                                        onChange={this.onInputChange}
                                        name="subject"
                                        id="related-drop"
                                        className="question-select">
                                        <option value={'QUOTATION_RELATED'}>お見積りに関するご質問</option>
                                        <option value={'PRODUCTION_RELATED'}>製造基準・技術的に関するご質問</option>
                                        <option value={'PRICING_RELATED'}>ご注文やサービスご利用に関するご質問</option>
                                        <option value={'PAYMENT_RELATED'}>お支払いに関するご質問</option>
                                        <option value={'QUALITY_RELATED'}>出荷に関するご質問</option>
                                        <option value={'REQUEST'}>無料基板サンプル請求</option>
                                        <option value={'OTHER'}>その他</option>
                                    </select>

                                }
                                {/*<select*/}
                                {/*value={this.state.subject}*/}
                                {/*onChange={this.onInputChange}*/}
                                {/*name="subject"*/}
                                {/*className="question-select">*/}
                                {/*<option value={'QUOTATION_RELATED'}>お見積りに関するご質問</option>*/}
                                {/*<option value={'PRODUCTION_RELATED'}>製造基準・技術的に関するご質問</option>*/}
                                {/*<option value={'PRICING_RELATED'}>ご注文やサービスご利用に関するご質問</option>*/}
                                {/*<option value={'PAYMENT_RELATED'}>お支払いに関するご質問</option>*/}
                                {/*<option value={'QUALITY_RELATED'}>出荷に関するご質問</option>*/}
                                {/*<option value={'OTHER'}>その他</option>*/}
                                {/*</select>*/}


                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-offset-3">
                            <FormFieldValidationError errors={this.state.subjectError}/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="user-inquiry-form-row-margin">
                            <div className="col-md-3">
                                <div className="text-right">
                                    <label>
                                        <FormattedMessage id="app.inquiry-form.inquiry"
                                                          defaultMessage="Inquiry"
                                                          description=""/>
                                        <span className="mandatory-star"> *</span>
                                    </label>
                                </div>
                            </div>
                            <div className="col-md-6 no-padding-left">
                                    <textarea type="text"
                                              className=" inquiry-text-area"
                                              name="inquiry"
                                              value={this.state.inquiry}
                                              onChange={this.onInputChange}
                                              rows={5}
                                    />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-offset-3">
                            <FormFieldValidationError errors={this.state.inquiryError}/>
                        </div>
                    </div>
                    {/*<div className="row hidden">
                            <div className="user-inquiry-form-row-margin">
                                <div className="col-md-10 col-md-offset-2 file-up-div ">

                                    <FilePond
                                        files={this.state.files}
                                        allowMultiple={true}
                                        maxFiles={3}
                                        onupdatefiles={fileItems => {
                                            // Set currently active file objects to this.state
                                            this.setState({
                                                files: fileItems.map(fileItem => fileItem.file)
                                            });
                                            console.log("file",this.state.files)
                                        }}
                                    />
                                </div>
                            </div>
                        </div>*/}

                    <div className="row">
                        <div className="user-inquiry-form-row-margin">
                            <div className="col-md-offset-2">
                                <div>
                                    {/* <ReCaptcha
                                            ref={(el) => {this.captchaDemo = el;}}
                                            size="normal"
                                            render="explicit"
                                            data-theme="dark"
                                            sitekey="6LfJfI8UAAAAAOVOMsDTvwOSInfUZFwDrxumxImg"
                                            onloadCallback={this.onLoadRecaptcha}
                                            verifyCallback={this.verifyCallback}
                                        />*/}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="user-inquiry-form-row-margin move-btn-inquiry-right-mobile">
                            <div className="col-md-3 col-md-offset-10">
                                <button onClick={this.onSubmit} className="btn btn-success"
                                        disabled={this.state.btnDisabled}>
                                    {/*<FormattedMessage id="app.inquiry-form.send"*/}
                                    {/*defaultMessage="Send"*/}
                                    {/*description=""/>*/}
                                    送信
                                </button>
                            </div>
                        </div>
                    </div>
                    {/*</form>*/}
                </div>

                <Modal dialogClassName="message-modal" show={this.state.show} onHide={this.handleClose}>
                    <Modal.Header closeButton>
                        <div className="title-1 color-text">
                            <FormattedMessage id="app.inquiry-form.success"
                                              defaultMessage="Success"
                                              description=""/>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="color-text">
                            <div className="row">
                                <div className="col-md-12 data-label">
                                    お客様のお問合せ内容をKITCUT管理チームに送りました。<br/>
                                    しばらくお待ちください。

                                </div>


                            </div>
                            <div className="form-row-spacer"></div>

                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="col-md-12">

                            <button className="btn btn-primary col-md-3 pull-right btn-inquiry-sent-close" onClick={this.handleClose}>
                                <FormattedMessage id="app.common.msg-box.close"
                                                  defaultMessage="Close"
                                                  description=""/>
                            </button>

                        </div>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}

export default UserInquiryForm;



// WEBPACK FOOTER //
// ./src/components/Site/UserInquiryForm/UserInquiryForm.js